// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__1bxM6","balanceDisclaimer":"posDashboard_balanceDisclaimer__2Llxz"};